export const appearancePath = () => '/settings/appearance' as const;
